import { SavedActivityInputPreview } from '../../lib/followUp';
import {
  StepActivitiesState,
  StepResourceModeState,
  getStepResourceMode,
} from '../../lib/mailSequence';
import { SavedActivityInputPreviewWithActivityIndex } from '../../components/Modals/MultiSignatureModals/ReviewSignerDetailsModal';

export type SignerActivityLocator = {
  source: 'default' | 'step';
  stepIndex: number;
  localIndex: number;
};

const needsSignerAssignment = (activity: SavedActivityInputPreview): boolean =>
  Boolean(
    activity.multiSignatureAssessmentConfig &&
      !activity.sendFollowUpActivityInputRaw?.programAssessmentSignatureUsers,
  );

/** Collect multi-sig forms that still need team-member / signer assignment. */
export const collectUnsignedMultiSigActivities = (
  defaultActivities: SavedActivityInputPreview[],
  stepActivitiesState: StepActivitiesState,
  stepResourceModes: StepResourceModeState,
  stepCount: number,
): {
  activities: SavedActivityInputPreviewWithActivityIndex[];
  locators: SignerActivityLocator[];
} => {
  const activities: SavedActivityInputPreviewWithActivityIndex[] = [];
  const locators: SignerActivityLocator[] = [];

  defaultActivities.forEach((activity, localIndex) => {
    if (!needsSignerAssignment(activity)) return;
    locators.push({ source: 'default', stepIndex: 0, localIndex });
    activities.push({ ...activity, activityIndex: activities.length });
  });

  for (let stepIndex = 1; stepIndex < stepCount; stepIndex++) {
    const mode = getStepResourceMode(stepResourceModes, stepIndex);
    const list = stepActivitiesState[stepIndex] ?? [];
    // Custom: full list. Inherit: extras only (Mail #1 forms covered above).
    if (mode !== 'custom' && mode !== 'inherit_mail_one') continue;
    list.forEach((activity, localIndex) => {
      if (!needsSignerAssignment(activity)) return;
      locators.push({ source: 'step', stepIndex, localIndex });
      activities.push({ ...activity, activityIndex: activities.length });
    });
  }

  return { activities, locators };
};
